import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * Подпись поля. `tone="filter"` — мелкая серая подпись над фильтром (12px, text-2), как в макете «Пользователи».
 * Связь с полем — только через htmlFor/id; удобнее через <FormField> (components/app).
 */
const labelVariants = cva(
  "font-semibold leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      tone: {
        default: "text-[13px] text-text",
        filter: "text-xs text-text-2",
      },
    },
    defaultVariants: { tone: "default" },
  }
)

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<
  HTMLLabelElement,
  LabelProps
>(({ className, tone, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ tone }), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label, labelVariants }
